<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/subscription-account']" translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/import-export-home']">{{ this.mng_impexp_title }}</a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>IMPORT_EXPORT_SECTION.EXP_DATA</span>
</div>

<tb-header specificTitle="IMPORT_EXPORT_SECTION.EXP_DATA" [specificSubTitle]="this.subDescriSelected +' ('+ this.subKeySelected +')'"></tb-header>

<div class="contentGlobal">
    <div style="display: flex; flex-direction: row">
        <div style="width: 85%">
            <mat-stepper [orientation]="(stepperOrientation | async)!" #stepper [linear]="true">
                <ng-template matStepperIcon="edit" let-index="index">
                    {{ index + 1 }}
                </ng-template>
                <mat-step name="1-ExportOptions" [completed]="favoriteExport !== undefined">
                    <div class="containerStepper">
                        <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.CHOOSE_CONFIGURATION</span></ng-template>
                        <mat-card class="fuse-card-grid">
                            <mat-card-title translate><span translate>IMPORT_EXPORT_SECTION.CHOOSE_DATA_TO_EXPORT</span></mat-card-title>
                            <mat-card-content style="padding: 1.5rem">
                                <mat-radio-group class="radio-group" #exportTypeRadioGroup [(ngModel)]="favoriteExport" (change)="changeFavExport()" name="exportTypeRadioGroup">
                                    <mat-radio-button class="radio-button" value="entireDb" #entireDb>
                                        <span translate class="text-bold">IMPORT_EXPORT_SECTION.ENTIRE_DB</span> &nbsp;-&nbsp;
                                        <span translate>IMPORT_EXPORT_SECTION.ENTIRE_DB_DESCRI</span>
                                    </mat-radio-button>
                                    <mat-radio-button class="radio-button" value="chosenTables" #chosenTables checked>
                                        <span translate class="text-bold">IMPORT_EXPORT_SECTION.CHOSEN_TABLES</span> &nbsp;-&nbsp;
                                        <span translate>IMPORT_EXPORT_SECTION.CHOSEN_TABLES_DESCRI</span>
                                    </mat-radio-button>
                                </mat-radio-group>
                            </mat-card-content>
                        </mat-card>
                        <div class="text-center">
                            <button mat-stroked-button matStepperPrevious (click)="clean()"><span translate>COMMONS.BACK</span></button>
                            <button mat-stroked-button color="secondary" matStepperNext *ngIf="favoriteExport === 'entireDb'" (click)="goToSummary()">
                                <span translate>COMMONS.NEXT</span>
                            </button>
                            <button mat-stroked-button color="secondary" matStepperNext *ngIf="favoriteExport === 'chosenTables'" (click)="loadTables()">
                                <span translate>COMMONS.NEXT</span>
                            </button>
                        </div>
                    </div>
                </mat-step>

                <mat-step name="2-Select Tables" [completed]="this.checklistSelection.selected.length > 0" *ngIf="showListTables">
                    <div class="containerStepper">
                        <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.CHOSEN_TABLES</span> </ng-template>
                        <mat-card class="fuse-card-grid" [hidden]="showProcessStarted">
                            <mat-card-title translate><span translate>IMPORT_EXPORT_SECTION.CHOSEN_TABLES_DESCRI</span></mat-card-title>
                            <mat-card-content style="padding: 1.5rem">
                                <div class="divCardActionRow">
                                    <mat-slide-toggle name="CollapseExpandTree" (ngModel)="(favoriteTreeView)" (change)="collapseExpandChange($event)">
                                        <span translate class="text-bold" *ngIf="!favoriteTreeView">IMPORT_EXPORT_SECTION.EXPAND_ALL</span>
                                        <span translate class="text-bold" *ngIf="favoriteTreeView">IMPORT_EXPORT_SECTION.COLLAPSE_ALL</span>
                                    </mat-slide-toggle>
                                </div>

                                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                                        <button mat-icon-button disabled></button>
                                        <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)" (change)="todoLeafItemSelectionToggle(node)">{{ node.name }}</mat-checkbox>
                                    </mat-tree-node>
                                    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                                        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.item">
                                            <mat-icon class="mat-icon-rtl-mirror">{{
                                                treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                                            }}</mat-icon>
                                        </button>
                                        <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)" (change)="todoItemSelectionToggle(node)">{{ node.name }}</mat-checkbox>
                                    </mat-tree-node>
                                </mat-tree>
                            </mat-card-content>
                        </mat-card>
                        <div class="text-center">
                            <button mat-stroked-button matStepperPrevious><span translate>COMMONS.BACK</span></button>
                            <button mat-stroked-button color="secondary" matStepperNext [disabled]="this.checklistSelection.selected.length === 0">
                                <span translate>COMMONS.NEXT</span>
                            </button>
                        </div>
                    </div>
                </mat-step>

                <mat-step name="3-summary" [completed]="isStepComplete == true">
                    <div class="containerStepper">
                        <ng-template matStepLabel><span translate>COMMONS.SUMMARY</span></ng-template>
                        <mat-card class="fuse-card-grid">
                            <mat-card-title translate><span translate>COMMONS.SELECTED_ITEMS</span></mat-card-title>
                            <mat-card-content style="padding: 1.5rem">
                                <div *ngIf="showListTables">
                                    <span translate class="text-bold">COMMONS.TOTAL_AMOUNT</span> : {{ getTableList(2).length }}
                                    <br />

                                    <div id="selectedTableContainer" style="display: flex; flex-direction: row; flex-wrap: wrap" [ngClass]="{ 'line-clamp-10': !showMore }">
                                        <div *ngFor="let table of getTableList(2)" class="feature-layout">
                                            <span translate style="white-space: pre">{{ table.name }}</span>
                                        </div>
                                    </div>
                                    <div class="CollapseContentStyle text-right" style="margin-top: 2rem">
                                        <button *ngIf="showMore" mat-button color="primary" (click)="hideDetails(selectedTableContainer)">
                                            <span translate style="font-size: 1.1rem">COMMONS.COLLAPSE</span>
                                        </button>
                                        <button *ngIf="!showMore" mat-button color="primary" (click)="showDetails(selectedTableContainer)">
                                            <span translate style="font-size: 1.1rem">COMMONS.READ_MORE </span>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="!showListTables">
                                    <span translate>IMPORT_EXPORT_SECTION.ENTIRE_DB</span>
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <div class="text-center">
                            <button mat-stroked-button color="secondary" matStepperPrevious><span translate>COMMONS.BACK</span></button>
                            <button mat-stroked-button color="secondary" matStepperNext (click)="doExportData()">
                                <span translate>COMMONS.NEXT</span>
                            </button>
                        </div>
                    </div>
                </mat-step>

                <mat-step name="4-logs&results">
                    <div class="containerStepper" #expConfig>
                        <ng-template matStepLabel><span translate>IMPORT_EXPORT_SECTION.LOGS_RESULTS</span> </ng-template>
                        <mat-card class="fuse-card-grid">
                            <mat-card-content style="padding: 1.5rem" *ngIf="logs === undefined">
                                <div>
                                    <h3 translate>IMPORT_EXPORT_SECTION.EXPORT_STARTED</h3>
                                    <br />
                                    <span translate>IMPORT_EXPORT_SECTION.GRAFANA_LOGS</span>

                                    <button mat-icon-button color="primary" (click)="refreshFrame()">
                                        <mat-icon>refresh</mat-icon>
                                    </button>
                                </div>

                                <div id="grafanalogscontainer">
                                    <div id="AppFrame4" class="codeContainer">
                                        <p *ngFor="let log of grafanaLogsExtracted">
                                            <span class="codeDate">{{ log[0] }}</span
                                            >&nbsp;&nbsp;{{ log[1] }}
                                        </p>
                                    </div>
                                </div>
                            </mat-card-content>

                            <mat-card-content style="padding: 1.5rem" *ngIf="logs === undefined">
                                <div>
                                    <div class="message-box info" style="font-size: 1.1rem">
                                        {{ 'IMPORT_EXPORT_SECTION.WAIT_END_EMAIL_EXPORT' | translate }}
                                    </div>
                                </div>
                            </mat-card-content>

                            <mat-card-content style="padding: 1.5rem" *ngIf="logs !== undefined">
                                <h3 translate>COMMONS.FAILED_OPERATION</h3>
                                <div class="message-box error">{{ logs }}</div>
                            </mat-card-content>
                            <mat-card-actions align="center">
                                <button mat-button color="primary" (click)="stepper.reset(); clean()">
                                    <span translate> IMPORT_EXPORT_SECTION.GO_IMP_EXP_HOME</span>
                                            <mat-icon>arrow_right_alt</mat-icon>
                                            </button>
                                            <button mat-button color="primary" (click)="goToHistoryExport()">
                                    <span translate> IMPORT_EXPORT_SECTION.GO_EXP_HISTORY</span><mat-icon>arrow_right_alt</mat-icon>
                                </button>
                                            </mat-card-actions>
                        </mat-card>
                        </div>
                </mat-step>
            </mat-stepper>
            <div *ngIf="loading">
                <tb-loading></tb-loading>
            </div>
            </div>
            </div>
        </div>